<template>
  <div class="mb-2">
    <SupplierOrderHeaderCardComponent
      :open="open"
      :supplier-order="supplierOrderModel"
      :supplier-order-status="supplierOrderStatus"
      @delete="deleteSupplierOrder(supplierOrderModel)"
      @open-category-modal="handleOpenItemByCategoryModal(supplierOrderModel)"
      @edit="$emit('editSupplierOrder', supplierOrderModel)"
      @receive-order="handleProcessReceiveOrder"
      @toggle-open="openCardWithSupplierOrder"
    />
  </div>
  <div v-if="open">
    <SupplierOrderTableCardComponent
      :supplier-order="supplierOrderModel"
      :edition-mode="editionMode"
      @delete-item="handleDeleteItemFromSupplierOrderItems"
      @update-supplier-order="handleUpdateSupplierOrder"
    />
  </div>
  <SupplierItemsModal
    v-if="isItemModalOpen"
    v-model="selectedItem"
    :open="isItemModalOpen"
    :can-select-category="true"
    :full-model-response="true"
    :supplier-order="supplierOrderModel"
    @selected-item="handleSelectedItem"
    @close="isItemModalOpen = false"
  />
  <SupplierOrderModal
    v-if="isSupplierOrderModalOpen"
    v-model="supplierOrderModel"
    :open="isSupplierOrderModalOpen"
    :refresh-function="refreshFunction"
    :dossier="selectedSupplierOrderDossier"
    :supplier-order-id="selectedSupplierOrderId"
    @fetch-supplier-orders="$emit('refresh')"
    @close="handleCloseSupplierOrderModal"
  />
  <SupplierOrderReceiveOrderModal
    v-if="isReceiveOrderModal"
    v-model="supplierOrderModel"
    :open="isReceiveOrderModal"
    :refresh-function="refreshFunction"
    :dossier="selectedSupplierOrderDossier"
    :supplier-order-id="selectedSupplierOrderId"
    @refresh-supplier="$emit('refresh')"
    @close="isReceiveOrderModal=false"
  />
  <ToastUndoComponent
    :text="$t('toasts.deleted_f', { var: $t('global.order') })"
  />
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex'
import SupplierOrderModal from '@ui/modal/supplierOrder/SupplierOrderModal'
import {InvoiceableType} from '@/assets/enums'
import ToastUndoComponent from "@c/addf-package/components/BaseToast/ToastUndoComponent.vue";
import SupplierItemsModal from "@ui/modal/supplierOrder/components/SupplierItemsModal.vue";
import SupplierOrderHeaderCardComponent from "@/views/supplierOrder/components/SupplierOrderHeaderCardComponent.vue";
import SupplierOrderTableCardComponent from "@/views/supplierOrder/components/SupplierOrderTableCardComponent.vue"
import SupplierOrderReceiveOrderModal from "@ui/modal/supplierOrder/components/SupplierOrderReceiveOrderModal.vue";

export default {
  name: 'SupplierOrderCardComponent',
  components: {
    SupplierOrderReceiveOrderModal,
    SupplierOrderTableCardComponent,
    SupplierOrderHeaderCardComponent,
    SupplierItemsModal,
    ToastUndoComponent,
    SupplierOrderModal,
  },
  props: {
    editionMode: {
      required: true,
      type: Boolean
    },
    supplierOrder: {
      required: true,
      type: Object
    },
    index: {
      required: true,
      type: [String, Number]
    }
  },
  emits: ['editSupplierOrder', 'refresh', 'refresh-supplier-order'],
  data() {
    return {
      search: '',
      open: false,
      supplierOrderModel: null,
      isSupplierOrderModalOpen: false,
      isItemModalOpen: false,
      isReceiveOrderModal: false,
      selectedSupplierOrderItem: null,
      selectedSupplierOrderId: null,
      selectedSupplierOrderIndex: null,
      selectedSupplierOrderDossier: null,
      selectedItem: null,
      supplier: null,
      InvoiceableType: InvoiceableType,
      internalInvoiceableType: 'all'
    }
  },
  computed: {
    ...mapGetters({
      filters: 'supplierOrder/getFilters',
      initialMetadata: 'metadata/getInitialMetadata',
      errors: 'auth/getErrors'
    }),
    supplierOrderStatus() {
      if (!this.initialMetadata) return null
      return this.initialMetadata?.enums?.supplier_order_status?.find(
        (status) => status.id === this.supplierOrderModel?.status
      )
    },
  },
  watch: {
    selectedItem(newValue) {
      if (newValue) {
        this.processUpdateInvoiceItemAction({
          invoice_id: this.selectedSupplierOrderId,
          content: {item_id: newValue.id},
          successCallback: () => {
            this.$h.toastify(this.$t('toasts.item_added_to_invoice'), {
              className: 'toastify-content success'
            })
            this.processFetchInvoiceIDAction({
              id: this.selectedSupplierOrderId,
              supplier_order_index: this.selectedSupplierOrderIndex,
              isSupplierOrder: true
            })
          }
        })
      }
    },
    supplierOrder(newValue) {
      this.supplierOrderModel = newValue;
      this.open = false
    }
  },
  mounted() {
    this.supplierOrderModel = this.supplierOrder;
  },
  methods: {
    ...mapActions({
      processFetchAllSupplierOrdersAction: 'supplierOrder/fetchAllSupplierOrders',
      processFetchSupplierOrderByIDAction: 'supplierOrder/fetchSupplierOrderByID',
      processUpdateSupplierOrderAction: 'supplierOrder/updateSupplierOrder',
      processUpdateInvoiceItemAction: 'invoicing/updateInvoiceItem',
      processFetchInvoiceIDAction: 'invoicing/fetchInvoiceID',
      processDeleteSupplierOrderByIdAction: 'supplierOrder/deleteSupplierOrderById',
      processUndoDeleteSupplierOrderByIdAction: 'supplierOrder/undoDeleteSupplierOrderById'
    }),
    ...mapMutations({
      processAddSupplierOrderItemToSupplierOrderMutation: 'supplierOrder/addSupplierOrderItemToSupplierOrder',
      processSetSupplierOrderMutation: 'supplierOrder/setSupplierOrder',
      processRemoveSupplierOrderAtIndexMutation: 'supplierOrder/removeSupplierOrderAtIndex'
    }),
    async openCardWithSupplierOrder() {
      this.open=!this.open
      if (this.open) {
        await this.processFetchSupplierOrderByIDAction({
          id: this.supplierOrderModel.id
        }).then((response) => {
          this.supplierOrderModel = response.supplier_order
        })
      }
    },
    handleSelectedItem(selected_item) {
      this.processSetSupplierOrderMutation(this.supplierOrderModel)
      const new_supplier_order_item = {
        id: null,
        supplier_order_id: this.supplierOrderModel.id,
        item_id: selected_item.item.id,
        name: selected_item.item.name_index,
        quantity: selected_item.item.quantity,
        quantity_added: selected_item.item.quantity,
        price_htva: selected_item.item.default_purchase_price_htva,
        price_tva_value: selected_item.item.default_purchase_price_tva_value,
        price_tvac: selected_item.item.default_purchase_price_tvac,
        tva: parseFloat(selected_item.item.tva),
        rounded: false,
        internal_note: null,
      }
      this.supplierOrderModel.item_ids.push(selected_item.item.id)
      this.processAddSupplierOrderItemToSupplierOrderMutation(new_supplier_order_item)
      this.isItemModalOpen = false
    },
    handleCloseSupplierOrderModal() {
      this.selectedSupplierOrderDossier = null
      this.selectedSupplierOrderId = null
      this.isSupplierOrderModalOpen = false
    },
    handleProcessReceiveOrder(supplier_order) {
      this.isReceiveOrderModal = true
      this.processSetSupplierOrderMutation(supplier_order)
    },
    refreshFunction() {
      // this.processFetchAllSupplierOrdersAction()
    },
    handleOpenItemByCategoryModal(supplier_order) {
      this.processSetSupplierOrderMutation(supplier_order)
      this.isItemModalOpen = true
    },
    handleDeleteItemFromSupplierOrderItems(index) {
      this.processSetSupplierOrderMutation(this.supplierOrderModel)
      this.processRemoveSupplierOrderAtIndexMutation(index)
    },
    handleUpdateSupplierOrder(supplier_order) {
      supplier_order.total_htva = this.supplierPriceHTVA(supplier_order);
      supplier_order.total_tvac = this.supplierOrderPriceTVAC(supplier_order);

      this.processUpdateSupplierOrderAction({
        supplier_order_id: supplier_order.id,
        supplier_order: supplier_order
      }).then((response) => {
          this.$h.toastSuccess(this.$t('toasts.updated_m', { var: this.$t('global.supplier_order') }));
          this.$emit('refresh');
          this.supplierOrderModel = response.supplier_order
      });
    },
    supplierPriceHTVA(supplier_order) {
      if (!supplier_order?.supplierOrderItems) {
        return "0.00";
      }
      const total = supplier_order.supplierOrderItems.reduce((sum, item) => {
        const price = parseFloat(item.price_htva);
        return sum + (isNaN(price) ? 0 : price);
      }, 0);
      return total.toFixed(2);
    },
    supplierOrderPriceTVAC(supplier_order) {
      return (
        supplier_order.supplierOrderItems.reduce((accumulator, item) => {
          const price = parseFloat(item.price_tvac) || 0;
          const reduction = parseFloat(item.reduction) || 0;
          const quantity = parseFloat(item.quantity) || 0;

          return accumulator + (price * (1 - reduction / 100) * quantity);
        }, 0) || 0
      ).toFixed(2);
    },
    deleteSupplierOrder(supplier_order) {
      this.processDeleteSupplierOrderByIdAction({
        id: supplier_order.id
      }).then(response => {
        this.$emit('refresh')
        this.restoreSupplier(supplier_order.id)
        this.open = false
      })
    },
    restoreSupplier(id) {
      this.$h.toastAction(
        'delete',
        this.$t('toasts.deleted_m', {var: this.$t('global.supplier_order')}),
        null,
        [
          {
            title: this.$t('button.cancel'),
            class: 'text-red-700',
            action: () => {
              this.processUndoDeleteSupplierOrderByIdAction({
                id: id
              }).then((response) => {
                this.$emit('refresh')
                this.$h.toastSuccess(
                  this.$t('toasts.reseted_m', {
                    var: this.$t('global.supplier_order')
                  })
                )
              })
            }
          }
        ]
      )

    }
  }
}
</script>
